/*
 * @Description: 申请单 – 报销申请
 */
import { RootObject } from '@/model/rootObject'
import https, { downloadExcel } from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import {
  CreateReimbRequestModel, ReimbRequestIdListModel, ReimbRequestListParamModel,
  ReimbRequestModel, ReimbRequestPageModel, ReimbRequestPageParamModel, ReimbRequestSetPaymentDateModel,
  ReimbSetPurposeParamModel,
  UpdateReimbRequestModel

} from '@/model/application-form/reimbursementRequest'
import networkConfig from '@/config/default/net.config'

const baseUrl = '/base/payment/reimbursement'
export const excelReimbFileUpload = () => {
  return networkConfig.host + baseUrl + '/import/excel'
}

export const createReimbRequest = (params: CreateReimbRequestModel) => {
  return https().request<RootObject<number>>(baseUrl + '/add', Method.POST, params, ContentType.json)
}

export const updateReimbRequest = (params: UpdateReimbRequestModel) => {
  return https().request<RootObject<number>>(baseUrl + '/update', Method.POST, params, ContentType.json)
}

export const getReimbRequestPageList = (params: ReimbRequestPageParamModel) => {
  return https().request<RootObject<ReimbRequestPageModel>>(baseUrl + '/list', Method.POST, params, ContentType.json)
}

export const getReimbRequestPageListByUser = (params: ReimbRequestPageParamModel) => {
  return https().request<RootObject<ReimbRequestPageModel>>(baseUrl + '/listByUser', Method.POST, params, ContentType.json)
}

export const getReimbRequestAllList = (params: ReimbRequestListParamModel) => {
  return https().request<RootObject<ReimbRequestModel[]>>(baseUrl + '/list/all', Method.POST, params, ContentType.json)
}

export const setReimbPaymentDate = (params: ReimbRequestSetPaymentDateModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/set/paymentDate', Method.POST, params, ContentType.json)
}

export const setReimbSetPurpose = (params: ReimbSetPurposeParamModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/set/purpose', Method.POST, params, ContentType.json)
}

export const generateReimbApprovalForms = (params: ReimbRequestIdListModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/generate/approvalForms', Method.POST, params, ContentType.json)
}

export const getReimbRequestByIds = (params: ReimbRequestIdListModel) => {
  return https()
    .request<RootObject<ReimbRequestModel[]>>(baseUrl + '/get/selectedApprovalForms', Method.POST, params, ContentType.json)
}
export const cancelReimbApplication = (params: ReimbRequestIdListModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/cancel/application', Method.POST, params, ContentType.json)
}

export const getReimbRequestById = (id: number) => {
  return https()
    .request<RootObject<ReimbRequestModel>>(baseUrl + '/get/' + id, Method.GET, undefined, ContentType.json)
}

export const exportReimbTemplate = () => {
  return downloadExcel(baseUrl + '/export/excelTemplate', Method.GET, undefined)
}
